import { Box, Button, Flex, Grid, GridItem, PopoverHeader, Text } from '@chakra-ui/react';
import { ReactComponent as AlignBottomIcon } from 'assets/icons/align_bottom.svg';
import { ReactComponent as AlignCenterIcon } from 'assets/icons/align_center.svg';
import { ReactComponent as AlignLeftIcon } from 'assets/icons/align_left.svg';
import { ReactComponent as AlignMiddleIcon } from 'assets/icons/align_middle.svg';
import { ReactComponent as AlignRightIcon } from 'assets/icons/align_right.svg';
import { ReactComponent as AlignTopIcon } from 'assets/icons/align_top.svg';
import { useTranslation } from 'react-i18next';

import { AlignmentOption } from './AlignmentMenu.types';
import { AlignmentToggleTip } from './AlignmentToggleTip';

const alignmentOptions = [
  {
    label: 'top',
    value: AlignmentOption.Top,
    icon: <AlignTopIcon />,
  },
  {
    label: 'middle',
    value: AlignmentOption.Middle,
    icon: <AlignMiddleIcon />,
  },
  {
    label: 'bottom',
    value: AlignmentOption.Bottom,
    icon: <AlignBottomIcon />,
  },
  {
    label: 'left',
    value: AlignmentOption.Left,
    icon: <AlignLeftIcon />,
  },
  {
    label: 'center',
    value: AlignmentOption.Center,
    icon: <AlignCenterIcon />,
  },
  {
    label: 'right',
    value: AlignmentOption.Right,
    icon: <AlignRightIcon />,
  },
];

interface AlignOptionsProps {
  onAlign: (alignOption: AlignmentOption) => void;
}

export const AlignmentOptions = ({ onAlign }: AlignOptionsProps) => {
  const { t } = useTranslation('editor_toolbar', { useSuspense: false, keyPrefix: 'alignment' });
  const header = t('alignTo');

  return (
    <Box>
      <PopoverHeader border='none' p={0}>
        <Flex alignItems='center' gap={2}>
          <Text fontSize='sm' fontWeight='semibold'>
            {header}
          </Text>
          <AlignmentToggleTip />
        </Flex>
      </PopoverHeader>
      <Grid templateColumns='repeat(3, minmax(0, 1fr))' gap={2} mt={2}>
        {alignmentOptions.map(({ value, label, icon }) => {
          const handleSelect = () => onAlign(value);
          return (
            <GridItem key={value}>
              <Button
                w='full'
                p={1}
                justifyContent='flex-start'
                onClick={handleSelect}
                variant='ghost'
                size='sm'
                fontWeight='normal'
                leftIcon={icon}
              >
                {t(`options.${label}` as keyof typeof t)}
              </Button>
            </GridItem>
          );
        })}
      </Grid>
    </Box>
  );
};
